const {abstractResource} = require("./abstractResource");

const service = abstractResource("FOLDERS");

const Folder = {
    ...service('folders'),
    get_form() {
        return {
            name: null,
            parent: null,
            default: false,
            shared_users: [],
            type: null,
            service_category: null,
            owner: null,
        }
    },

    get_default_note_folders() {
        return {
            'all': {
                name: 'Toutes les notes',
                label: 'all',
                parent: null,
                files: [],
            },
            'fav': {
                name: 'Favoris',
                label: 'fav',
                parent: null,
                files: [],
            },
            'shared': {
                name: 'Notes partagées avec moi',
                label: 'shared',
                parent: null,
                files: [],
            },
            'my': {
                name: 'Mes notes',
                label: 'my',
                parent: null,
                files: [],
            },
        }
    },

    get_default_report_folders(){
        return{
            'all': {
                name: 'Tous les compte-rendus',
                label: 'all',
                parent: null,
                files: [],
            },
            'fav': {
                name: 'Favoris',
                label: 'fav',
                parent: null,
                files: [],
            },
            'shared': {
                name: 'Compte-rendus partagées avec moi',
                label: 'shared',
                parent: null,
                files: [],
            },
            'my': {
                name: 'Mes compte-rendus',
                label: 'my',
                parent: null,
                files: [],
            },
        }
    },

    get_default_document_folders(){
        return {
            'all': {
                name: 'Tous les documents',
                label: 'all',
                parent: null,
                files: [],
            },
            'fav': {
                name: 'Favoris',
                label: 'fav',
                parent: null,
                files: [],
            },
            'shared': {
                name: 'Documents partagées avec moi',
                label: 'shared',
                parent: null,
                files: [],
            },
            'my': {
                name: 'Mes documents',
                label: 'my',
                parent: null,
                files: [],
            },
        }
    }
}

const FolderNoDepth = {
    ...service('folders-no-depth'),

    serviceFolders: [
        {
            name: 'ATS',
            service: '00000000-0000-0000-0000-000000000001'
        },
        {
            name: 'CRM',
            service: '00000000-0000-0000-0000-000000000002'
        },
        {
            name: 'Produit',
            service: '00000000-0000-0000-0000-000000000003'
        },
        {
            name: 'Project',
            service: '00000000-0000-0000-0000-000000000004'
        },
        {
            name: 'Compta',
            service: '00000000-0000-0000-0000-000000000005'
        },
        {
            name: 'Ticketing',
            service: '00000000-0000-0000-0000-000000000006'
        },
        {
            name: 'SIRH',
            service: '00000000-0000-0000-0000-000000000007'
        },        {
            name: 'Répertoire',
            service: '00000000-0000-0000-0000-000000000008'
        },

    ],
}

const File = {
    ...service('files'),
    get_form() {
        return {
            name: null,
            text: null,
            document: null,
            folder_parent: null,
            shared_users: [],
            favorite_users: [],
            type: null,
            size: 0,
            service_category: null,
            external_id: null,
        }
    }
}

module.exports = {
    Folder,
    File,
    FolderNoDepth,
}